import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import { theme } from './theme'
import { store } from './reduxStore'
import { Provider } from 'react-redux'
import React, { memo } from 'react'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { AppRoutes } from './AppRoutes'
import { SnackbarErrorWithDetails } from './components/shared/SnackbarErrorWithDetails'
import { CustomSnackbarContent } from './components/shared/CustomSnackbarContent'
import { SnackbarProvider } from 'notistack'

export const App = memo(() => {
  return (
    <Provider store={store}>
      <CssBaseline />
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <SnackbarProvider
            maxSnack={6}
            classes={{ containerRoot: 'z-alert' }}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            Components={{
              errorWithDetails: SnackbarErrorWithDetails,
              success: CustomSnackbarContent,
              error: CustomSnackbarContent,
              warning: CustomSnackbarContent,
              default: CustomSnackbarContent,
            }}
          >
            <AppRoutes />
          </SnackbarProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </Provider>
  )
})
